import ReactJson from "react-json-view";
import { useQuery } from "react-query";

import { Loader } from "common/helpers/HorizontalLoader";
import { request } from "common/components/request";

import { captureException } from "extensions/sentry";

import { v2 } from "common/config/api";

// Analytics section <-> api resource map.
const sectionToApiResource = {
    settlements: "settlement",
    authorizations: "authorization",
    chargebacks: "chargeback",
    fees: "fee",
    misc: "misc",
    all_fraud: "fraud",
    get psd2_fraud() {
        return this.all_fraud;
    },
    threedsflex: "threedsflex",
    fraudsight: "fraudsight"
};

export function TransactionMeta({ id, section }) {
    const { data, error, isLoading, isError } = useQuery(
        ["fetch_transaction_meta", id, section],
        () => request(v2.misc.transactionsDetail(sectionToApiResource[section]), {
            data: { transaction_ref: id }
        }),
        { retry: false }
    );

    const shouldCollapse = ({ name }) => ["PAZ_FILES", "PROCESSOR_RECORDS", "NORMALIZED_RECORD"].includes(name);

    if (isError) {
        captureException(error);
        return <p>Sorry! There was an error loading the meta data</p>;
    }

    return (
        <Loader loaded={!isLoading}>
            <ReactJson src={data} theme="apathy:inverted" displayObjectSize={false} shouldCollapse={shouldCollapse} iconStyle="triangle" collapseStringsAfterLength="30" displayDataTypes={false}/>
        </Loader>
    );
}
